import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="14.667">
    <path d="M11.528 8.862A.666.666 0 0111.057 10H9.333v2.667H6.666V10H4.942a.666.666 0 01-.471-1.138l3.528-3.529h-8v8a1.33 1.33 0 001.331 1.331h13.333a1.33 1.33 0 001.331-1.331v-8h-8zM14.669 0H1.331A1.331 1.331 0 000 1.331V4h16V1.331A1.331 1.331 0 0014.669 0z" />
  </svg>
);
